<template>
    <section class="popular-trips">
        <div class="container">
            <div class="popular-trips__container">
                <div class="popular-trips__titlebar">
                    <h4>Popular trips</h4>
                    <popular-trip-filter></popular-trip-filter>
                </div>
                <div class="popular-trips__list">
                    <journey-card
                        v-for="trip in popular.trips"
                        :key="trip.id"
                        :days="trip.days"
                        :link="trip.link"
                        :title="trip.title"
                        :summary="trip.summary"
                        :image="trip.image"
                        v-show="trip.visible"
                    ></journey-card>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { usePopularStore } from "@/vue/stores/popular.js";
import PopularTripFilter from "@/vue/components/PopularTripFilter";
import JourneyCard from "@/vue/components/JourneyCard";

export default {
    components: {
        PopularTripFilter,
        JourneyCard,
    },
    data() {
        return {
            popular: usePopularStore(),
        };
    },
};
</script>
